import projectsScheduleSqueleton from 'assets/images/project_management/empty_state/schedule/projects_schedule_squeleton.svg'
import { AvailableModules, Features } from 'generated/featureDefinitions'
import { ScheduleContributorsPageDocument } from 'generated/resources/graphql'

import { useCurrentSession } from 'modules/core/hooks/useCurrentSession'
import { useQuery } from 'modules/core/hooks/useQuery'
import i18n from 'modules/core/lib/i18n'

import { ResponsivePage } from 'modules/layout/components/ResponsivePage'
import { ProjectsUpsellRequestSources } from 'modules/project_management/components/upsells/constants'
import ContributorsSchedule from 'modules/project_management/pages/ScheduleContributorsPage/ContributorsSchedule'
import { ValidReasons } from 'modules/upsell/hooks/useCreateUpsellRequest'
import { UpsellingKit } from 'modules/upselling_kit/components'

const ContributorsListPage = () => {
  const {
    company: { id: companyId },
  } = useCurrentSession()
  const {
    data: page,
    loading,
    error,
  } = useQuery(ScheduleContributorsPageDocument, {
    variables: {
      companyId: companyId,
      featureIds: [Features.projects_overview],
    },
  })

  const isScheduleViewEnabled = !!page?.companies.featureAvailabilitiesConnection.nodes.find(
    (feature) => feature.id === Features.projects_overview
  )?.available

  const canSeeSchedules = !!page?.projectManagement._policies?.accessManageProjects.can

  return (
    <ResponsivePage.Body
      variant="fullscreen"
      showHeader={false}
      loading={loading}
      error={error}
      authorized={canSeeSchedules}
    >
      {isScheduleViewEnabled ? (
        <ContributorsSchedule />
      ) : (
        <UpsellingKit.EmptyState
          moduleRequested={AvailableModules.projects}
          // TODO: change feature to projects_planning
          featureRequested={Features.projects_overview}
          requestSource={ProjectsUpsellRequestSources.scheduleEmptyState}
          requestReason={ValidReasons.MissingFeature}
          background={projectsScheduleSqueleton}
          learnMoreNavigate={'/discover/news/calendar-view-in-projects'}
          title={i18n.t('project_management.schedule.upsell.title')}
          description={i18n.t('project_management.schedule.upsell.description')}
        />
      )}
    </ResponsivePage.Body>
  )
}

export default ContributorsListPage
